import React from 'react';
import { createRoot } from 'react-dom/client';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import GuestPageFooter from 'common/compounds/GuestPageFooter/GuestPageFooter';

/**
 * Creates and renders the guest footer app
 * @return {void}
 */
export default () => {
    const bootstrap = getBootstrap();
    const hideFooter = bootstrap.get('event.hideFooter', false);

    const footerContainerDiv = document.getElementById('footer-root');

    if (footerContainerDiv !== null && !hideFooter) {
        createRoot(footerContainerDiv).render(<GuestPageFooter showCalendar />);
    }
};
